import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/pro-light-svg-icons';

export function CommentDotsIcon({ color = '' }) {
  const styleObj: React.CSSProperties = color ? { color } : {};
  return <FontAwesomeIcon style={styleObj} icon={faCommentDots} size="xs" />;
}
